import http from './http';

const apiVersion = 'v2';
const menuUrl = `/${apiVersion}/menu`;

interface IRules {
	allowed_plans: string[];
}

export interface IMenuItem {
	_id: string;
	label: string;
	url: string | null;
	position: number;
	icon: string | null;
	children: IMenuItem[];
	access?: string[];
	shouldRefresh?: boolean;
	rules?: IRules[];
}

const getMenu = async (): Promise<IMenuItem[]> => {
	const { data } = await http.get<IMenuItem[]>(menuUrl);
	return data;
};

export { getMenu };
